import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCard from 'eco-design/sections/eco-section-card';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import useVideo from '../useVideo';

export default function Comp() {
    const { t } = useLang('theProduct.SectionG');
    const { locale = 'us' } = getLocal();
    const IS_JP_SITE = ['jp'].includes(locale);

    const { src } = useVideo({
        className: styles.comp,
        url: IS_JP_SITE
            ? 'https://websiteoss.ecoflow.com/upload/video/1745378819478/video3.mp4'
            : 'https://websiteoss.ecoflow.com/upload/video/1744880134714/bx-video.mp4',
        offset: '80%',
        duration: '200%',
    });

    return (
        <div id="SectionG">
            <EcoSpace />
            <EcoSectionCard
                label={t('label')}
                title={t('title')}
                desc={t.rich('desc', {
                    sub: (v: string) => (
                        <>
                            <br />
                            <span className="sub">{v}</span>
                        </>
                    ),
                })}
                layout="img-right"
                className={styles.comp}
                poster={
                    IS_JP_SITE
                        ? 'https://websiteoss.ecoflow.com/upload/image/1745378634060/video3-f.jpg'
                        : 'https://websiteoss.ecoflow.com/upload/image/1744880410529/bx-videofm.jpg'
                }
                pc={src}
                isVideo={true}
            />
            <EcoSpace />
        </div>
    );
}
